import { faqs } from "@/data";
import { useSEO, DEFAULT_SEO } from "@/lib/seo";
import Hero from "@/components/Hero";
import { Marquee } from "@/components/Extras";
import SocialProofTicker from "@/components/SocialProofTicker";
import Manifesto from "@/components/Manifesto";
import WebsiteScore from "@/components/WebsiteScore";
import BusinessIntake from "@/components/BusinessIntake";
import Packages from "@/components/Packages";
import Memberships from "@/components/Memberships";
import AddOns from "@/components/AddOns";
import WhoFor from "@/components/WhoFor";
import BeforeAfter from "@/components/BeforeAfter";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import LeadForm from "@/components/LeadForm";
import BlogTeaser from "@/components/BlogTeaser";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

const Landing = () => {
  useSEO(DEFAULT_SEO);
  return (
    <main data-testid="landing">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <Hero />
      <SocialProofTicker />
      <Marquee items={["48 HOUR LAUNCH", "DONE FOR YOU", "NO AGENCY PRICE TAG", "BUSINESS IN A BOX", "LIVE BY FRIDAY"]} />
      <WhoFor />
      <Manifesto />
      <BusinessIntake />
      <WebsiteScore />
      <BeforeAfter />
      <Packages />
      <Memberships />
      <AddOns />
      <Testimonials />
      <BlogTeaser />
      <FAQ />
      <LeadForm />
    </main>
  );
};

export default Landing;
